/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Warmup_AddInputs */

const en_us2_workout_logging_warmup_add = /** @type {(inputs: Workout_Logging_Warmup_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add warm-up`)
};

const pt_br2_workout_logging_warmup_add = /** @type {(inputs: Workout_Logging_Warmup_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar aquecimento`)
};

const es_419_workout_logging_warmup_add = /** @type {(inputs: Workout_Logging_Warmup_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar calentamiento`)
};

const pt_pt2_workout_logging_warmup_add = /** @type {(inputs: Workout_Logging_Warmup_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar aquecimento`)
};

const fr_fr2_workout_logging_warmup_add = /** @type {(inputs: Workout_Logging_Warmup_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter l'échauffement`)
};

const de_de2_workout_logging_warmup_add = /** @type {(inputs: Workout_Logging_Warmup_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufwärmen hinzufügen`)
};

const it_it2_workout_logging_warmup_add = /** @type {(inputs: Workout_Logging_Warmup_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi riscaldamento`)
};

/**
* | output |
* | --- |
* | "Add warm-up" |
*
* @param {Workout_Logging_Warmup_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_add = /** @type {((inputs?: Workout_Logging_Warmup_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_add(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_add(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_add(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_add(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_add(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_add(inputs)
	return en_us2_workout_logging_warmup_add(inputs)
});
export { workout_logging_warmup_add as "workout-logging.warmup_add" }